import Template from "backbone/projects/templates/asset.js.hamlc"

export default class AssetView extends Backbone.View
  events:
    "click .js-confirm-delete" : "delete"
    "click .js-delete"         : "showConfirmation"
    "click .js-cancel-delete"  : "cancelConfirmation"

  initialize: (options) ->
    @asset = options.asset
    @listenTo(@asset, "change", @render)

  render: ->
    @$el.html Template(asset: @asset, confirmDelete: @confirmDelete)
    this

  showConfirmation: ->
    @confirmDelete = true
    @render()

  cancelConfirmation: ->
    @confirmDelete = false
    @render()

  maskLoading: ->
    @$el.find(".image-wrapper").maskLoading()

  remove: ->
    @stopListening()
    super()

  delete: ->
    @asset.destroy
      success: =>
        @remove()
        contently.flash.notice("The image has been successfully removed from your project.")
      error: ->
        contently.flash.alert("There was an error deleting the image from your project.")



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/asset_view.js.coffee